import React from 'react';
import { TouchableOpacity } from 'react-native-gesture-handler';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import ChevronRight from '@/assets/icons/chevronRight';
import { Box } from '@/components/lib/components';
import { ExpiredCardTag } from '@/feature/deposit/components/ExpiredCardTag';
import { AccountStackParamList } from '@/navigation/types';
import { RemovableCardType } from '@/types/removable-cards';

import { BaseCardInfo } from './BaseCardItemInfo';
import { lineItemStyle, styles } from './styles';

export const ExpiredCardItem = ({ card }: { card: RemovableCardType }) => {
    const navigation = useNavigation<NativeStackNavigationProp<AccountStackParamList>>();
    const handlePress = () => {
        navigation.navigate('ManageExpiredDebitCardDetail', { selectedMethod: card });
    };

    return (
        <TouchableOpacity style={lineItemStyle} onPress={handlePress}>
            <Box flexDirection="row" flex={1} alignItems="center" testID={`debit-card-${card.payment_type_id}`}>
                <BaseCardInfo card={card} showDistributionAmount />
                <Box gap="s4" flexDirection="row" alignItems="center" justifyContent="center">
                    <Box style={styles.expiredCardTagContainer}>
                        <ExpiredCardTag />
                    </Box>
                    <Box alignItems="flex-end" justifyContent="center">
                        <ChevronRight />
                    </Box>
                </Box>
            </Box>
        </TouchableOpacity>
    );
};
